import { StarIcon, UserCheck2Icon } from 'lucide-react'

import Pill from '@/components/Pill'
import { capitalizeFirst } from '@/utilities/capitalizeFirst'

import type { Event as EventType } from '@/payload-types'

function DynamicIcon({ classification }: { classification: EventType['official'] }) {
  switch (classification) {
    case 'official':
      return <StarIcon className="size-4" />
    case 'unofficial':
      return <UserCheck2Icon className="size-4" />
  }
}

const classificationColorMap = {
  official: 'evergreen',
  unofficial: 'meltwater',
  joint: 'gray',
}

export const ClassificationBadge = ({
  classification,
}: {
  classification: EventType['official']
}) => {
  return (
    <Pill color={classificationColorMap[classification]}>
      <span>{capitalizeFirst(classification)}</span>
      <DynamicIcon classification={classification} />
    </Pill>
  )
}
